import { useMutation, useQueryClient } from "@tanstack/react-query";

import { errorHandler } from "#app/monitoring/errorHandler";
import { showErrorToast } from "#app/notifications";
import { upsertCustomInput } from "#modules/quoteRequestLines/infra/upsertCustomInput.api";

import { quoteRequestLineCustomInputsQuery } from "../../quoteRequestLines/infra/quoteRequestLineCustomInputs.query";

export const useUpsertCustomInput = (params: {
  quoteRequestLineId: string | undefined;
  options?: {
    onSuccess?: () => void;
    onError?: (err: Error) => void;
    onMutate?: () => void;
  };
}) => {
  const queryClient = useQueryClient();
  const { options } = params;

  const { mutate, ...rest } = useMutation({
    mutationFn: upsertCustomInput,
    onMutate: () => {
      options?.onMutate?.();
    },
    onSuccess: (_, variables) => {
      options?.onSuccess?.();
      void queryClient.invalidateQueries(quoteRequestLineCustomInputsQuery(variables.id));
    },
    onError: (err: Error) => {
      showErrorToast({ title: err.message });
      errorHandler(err);

      options?.onError?.(err);
    },
  });

  return { upsertCustomInput: mutate, ...rest };
};
